import React from 'react';
import { Web3Button } from '@web3modal/react';

function Web3ButtonPage() {
  return <Web3Button />;
}

export default Web3ButtonPage;
